import { render } from "./InputAutosuggest.vue?vue&type=template&id=2beec440"
import script from "./InputAutosuggest.vue?vue&type=script&lang=js"
export * from "./InputAutosuggest.vue?vue&type=script&lang=js"

import "./InputAutosuggest.vue?vue&type=style&index=0&id=2beec440&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__